import { Theme } from '../models/theme';

export const lightTheme: Theme = {
  name: 'light',
  colors: {
    primary: '#1a1a1a',
    secondary: '#f5f5f5',
    background: '#ffffff',
    surface: '#fafaf9',
    text: {
      primary: '#1a1a1a',
      secondary: '#78716c',
    },
    border: '#e7e5e4',
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6',
  },
  typography: {
    fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
    fontSize: {
      small: '0.875rem',
      medium: '1rem',
      large: '1.25rem',
      xlarge: '1.5rem',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      bold: 700,
    },
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  borderRadius: {
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.75rem',
  },
  shadows: {
    sm: '0 2px 4px rgba(0, 0, 0, 0.04)',
    md: '0 4px 12px rgba(0, 0, 0, 0.08)',
    lg: '0 10px 40px rgba(0, 0, 0, 0.1)',
  },
};

export const darkTheme: Theme = {
  name: 'dark',
  colors: {
    primary: '#fafaf9',
    secondary: '#292524',
    background: '#1a1a1a',
    surface: '#292524',
    text: {
      primary: '#fafaf9',
      secondary: '#a8a29e',
    },
    border: '#44403c',
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6',
  },
  typography: {
    fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
    fontSize: {
      small: '0.875rem',
      medium: '1rem',
      large: '1.25rem',
      xlarge: '1.5rem',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      bold: 700,
    },
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  borderRadius: {
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.75rem',
  },
  shadows: {
    sm: '0 2px 4px rgba(0, 0, 0, 0.2)',
    md: '0 4px 12px rgba(0, 0, 0, 0.3)',
    lg: '0 10px 40px rgba(0, 0, 0, 0.4)',
  },
};

export const warmTheme: Theme = {
  name: 'warm',
  colors: {
    primary: '#1c1917',
    secondary: '#57534e',
    background: '#f8f6f0',
    surface: '#fefefe',
    text: {
      primary: '#1c1917',
      secondary: '#57534e',
    },
    border: '#d6d3d1',
    success: '#10b981',
    error: '#ef4444',
    warning: '#d4af37',
    info: '#1e3a8a',
  },
  typography: {
    fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
    fontSize: {
      small: '0.875rem',
      medium: '1rem',
      large: '1.25rem',
      xlarge: '1.5rem',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      bold: 700,
    },
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  borderRadius: {
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.75rem',
  },
  shadows: {
    sm: '0 2px 4px rgba(28, 25, 23, 0.04)',
    md: '0 4px 12px rgba(28, 25, 23, 0.08)',
    lg: '0 10px 40px rgba(28, 25, 23, 0.1)',
  },
};

export const themes = {
  light: lightTheme,
  dark: darkTheme,
  warm: warmTheme,
};